var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMap = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 32.001,
    height: 32,
    viewBox: "0 0 32.001 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.771,
    cy: 3.39,
    rx: 1.771,
    ry: 3.39,
    transform: "translate(4.49 7.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.337,8.3,21.609,4.476a1.035,1.035,0,0,0-.381-.072H11.35L1.463.089A1.046,1.046,0,0,0,0,1.044V23.18a1.049,1.049,0,0,0,.619.954l10.086,4.523a1.051,1.051,0,0,0,.427.1h9.947l9.543,3.2a1.034,1.034,0,0,0,.332.05A1.046,1.046,0,0,0,32,30.958V9.272A1.046,1.046,0,0,0,31.337,8.3Zm-19.5,16.264h8.711v2.093H11.838Zm5.706-9.036a.887.887,0,0,0-1.439.029l-3.288,4.768a.888.888,0,0,1-.979.346V6.5H20.55V19.52ZM2.094,2.638l8.349,3.646V19.66l-1.657-1.3a.891.891,0,0,0-.966-.087l-1.523.8a.82.82,0,0,1-1.178-.334.886.886,0,0,0-1.629.484v1.29a.888.888,0,0,0,.527.812l6.426,2.857v2.06L2.094,22.506ZM29.906,29.507l-7.961-2.672V24.718l5.63,2.171a.889.889,0,0,0,1.15-1.147l-1.989-5.205a.889.889,0,0,0-1.516-.247L23.8,22.011a.886.886,0,0,1-1.394-.03l-.463-.614V6.856l7.961,3.126V29.507Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/map.d4bb0e86.svg";
export { ForwardRef as ReactComponent };